<!-- Translated: skip -->
<template>
  <Modal @close="localCloseModal" :wide="false" width="500px">
    <h2>RUT-avdrag</h2>

    <p>Genom att ange ditt personnummer nedan kan du få RUT-avdrag för denna tjänst.</p>
    <p>Ange 12 siffror i formatet ÅÅÅÅMMDD-XXXX. <span class="bold" v-if="isSwedish">För att kunna ansöka om RUT krävs att du betalar skatt i Sverige.</span></p>

    <p class="bold" v-if="!isSwedish">Det verkar som att du inte bokar från Sverige - för att kunna ansöka om RUT krävs att du betalar skatt i Sverige.</p>

    <p>För att kunna nyttja RUT-avdrag krävs att <b>städningen utförs samma år som betalning genomförs</b>. I annat fall finns risk för avslag hos Skatteverket. Det går bra att lägga till i efterhand via Mina sidor eller genom att ringa oss på <a href="tel:054-13 26 00">054&#8209;13&nbsp;26&nbsp;00</a>.</p>

    <input placeholder="ÅÅÅÅMMDD-XXXX" :class="{error: error}" type="text" @keydown="error = ''" @keyup="addDash" v-model="ssn" />

    <div v-if="!error"><br /><br /></div>

    <p class="error-text" v-if="error"><br />{{ error }}<br /><br /></p>

    <button class="small" :disabled="!valid" @click="click">Välj rutavdrag</button>
    <button class="small white border" @click="cancel">Jag vill inte ha rutavdrag</button>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import Login from '@/components/payments/Login';

import languageDetector from '@/mixins/languageDetector';

import moment from 'moment';
import checkdigit from 'checkdigit';

export default {
  props: {
    params: {},
  },
  mixins: [languageDetector],
  components: {
    Modal,
    Login,
  },
  data() {
    return {
      ssn: '',
      loading: false,
      error: false,
      appendedCount: 0,
    };
  },
  mounted() {
    this.ssn = (this.$store.state.cart.ssn || '');
  },
  computed: {
    valid() {
      this.error = '';

      if (this.ssn.length === 10 && this.ssn.indexOf('-') === -1 && this.ssn.indexOf('-') === -1) {
        this.error = 'Angivet personnummer saknar ett streck (ÅÅÅÅMMDD-XXXX)';
        return false;
      }

      if (this.ssn.length > 13) {
        this.error = 'Angivet personnummer är för långt';
        return false;
      }

      if (this.ssn.length === 11) {
        const firstTwo = this.ssn.substr(0, 2);
        if (firstTwo !== '19' && firstTwo !== '20') {
          this.error = 'Angivet personnummer saknar de första två siffrorna';
          return false;
        }
      }

      if (this.ssn.length < 13) {
        return false;
      }

      const year = this.ssn.substr(0, 4);
      const month = this.ssn.substr(4, 2);
      const monthForDate = parseInt(month, 10) - 1;
      const day = this.ssn.substr(6, 2);
      const date = moment([year, monthForDate, day]);
      const lastNumber = this.ssn.substr(this.ssn.length - 1, 1);

      if (!date.isValid()) {
        this.error = `Datumet (${year}${month}${day}) i angivet personnummer stämmer inte`;
        return false;
      }

      const valid = checkdigit.mod10.isValid((this.ssn.substr(2, 11)).replace('-', '').replace('+', ''));
      if (!valid) {
        this.error = `Checksiffran (${lastNumber}) stämmer inte`;
        return false;
      }

      return true;
    },
    isSwedish() {
      return this.browserLanguage.indexOf(this.SITE_CONFIG.languages.default) !== -1;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    localCloseModal() {
      this.closeModal();
    },
    cancel() {
      this.$store.state.cart.ssn = '';
      this.params.cancel();
      this.closeModal();
    },
    addDash() {
      this.ssn = this.ssn.replace(/[^0-9-]/g, '');
      this.ssn = this.ssn.replace(/[+]/g, '-');

      // When the first 8 have been entered
      const firstTwo = this.ssn.substr(0, 2);
      if (firstTwo === '19' || firstTwo === '20') {
        if ((this.ssn || '').length === 8 && !this.appendedCount) {
          this.ssn = `${this.ssn}-`;
          this.appendedCount += 1;
        }
      }

      // If you accidently add another dash
      if ((this.ssn || '').length === 10 && this.ssn.substr(8, 2) === '--') {
        this.ssn = this.ssn.substr(0, 9);
      }

      // If you entered all without the dash
      if ((this.ssn || '').length === 12 && this.ssn.indexOf('-') === -1 && this.ssn.indexOf('+') === -1 && !this.appendedCount) {
        const part1 = this.ssn.substr(0, 8);
        const part2 = this.ssn.substr(8, 4);
        this.ssn = `${part1}-${part2}`;
      }
    },
    click() {
      if (this.valid) {
        this.$store.state.cart.ssn = this.ssn;
        this.params.click();
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

input
  input()
  &.error
    border-color warning

.error-text
  color warning

h2
  font-size: 20px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()
  uppercase()

hr
  height 1px
  background-color light-blue-grey
  margin-top 20px
  margin-bottom 20px

.modalo
  text-align center

.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  margin-top: 30px
  text-align: left

  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 0.9em
    uppercase()
    .icon
      margin-right 3px
      position relative
      top -1px
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c
</style>



// WEBPACK FOOTER //
// RutModal.vue?6f7590d5